import { AddressElement } from '@stripe/react-stripe-js';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { StripeAddressValue } from './StripePaymentForm';

interface GiftBillingAddressProps {
  country: string;
  onChange: (value: StripeAddressValue, complete: boolean) => void;
  className?: string;
  sectionRef: React.Ref<HTMLDivElement>;
  children?: React.ReactNode;
}

/** a ship-to-recipient gift bills the buyer, and web needs their full address, which the card form does not collect */
export default function GiftBillingAddress({
  country,
  onChange,
  className,
  sectionRef,
  children,
}: GiftBillingAddressProps) {
  const { t } = useTranslation();
  return (
    <div className={className} ref={sectionRef}>
      <h4>{t('hardware_first_checkout_gift_billing_address')}</h4>
      <AddressElement
        options={{
          // link autofills only a shipping-mode element; the value is still used as the billing address
          mode: 'shipping',
          display: { name: 'split' },
          fields: { phone: 'always' },
          validation: { phone: { required: 'always' } },
          allowedCountries: [country],
          defaultValues: { address: { country } },
        }}
        onChange={(event) => onChange(event.value, event.complete)}
      />
      {children}
    </div>
  );
}
